import React, {FC, ReactNode} from 'react';
import {
    Modal,
    ModalOverlay,
    Dialog,
    Heading,
    Button,
    ModalOverlayProps,
} from 'react-aria-components';
import cx from 'clsx';
import {SvgIcon} from '@montana/shared/svg-icon';

export interface IDrawerProps extends ModalOverlayProps {
    children: ReactNode;
    title?: string;
    side?: 'left' | 'right' | 'top' | 'bottom';
    isDismissable?: boolean;
    className?: string;
    showCloseButton?: boolean;
    isInstant?: boolean;
}

export const Drawer: FC<IDrawerProps> = ({
    children,
    title,
    side = 'right',
    isDismissable = false,
    className,
    showCloseButton = false,
    isInstant = false,
    ...props
}) => {
    return (
        <ModalOverlay
            {...props}
            isDismissable={isDismissable}
            className={(renderProps) => cx(
                'drawer-overlay',
                {
                    'is-entering': renderProps.isEntering && !isInstant,
                    'is-exiting': renderProps.isExiting && !isInstant,
                },
                className
            )}
        >
            <Modal
                className={(renderProps) => cx(
                    'drawer-content',
                    `drawer-content--${side}`,
                    {
                        'is-entering': renderProps.isEntering && !isInstant,
                        'is-exiting': renderProps.isExiting && !isInstant,
                    }
                )}

            >
                <Dialog className="drawer-dialog" aria-label={props?.['aria-label'] || title || 'Drawer'}>
                    {({close}) => (
                        <>
                            {title && (
                                <Heading slot="title" className={cx('drawer-header', 'drawer-title')}>
                                    {title}
                                </Heading>
                            )}
                            {showCloseButton && (
                                <Button onPress={close} className={cx('drawer-close-button', `drawer-close-button--${side}`)} aria-label="Close">
                                    <SvgIcon iconName="close" className="drawer-close-icon"/>
                                </Button>
                            )}
                            <div className="drawer-body">
                                {children}
                            </div>
                        </>
                    )}
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
};

Drawer.displayName = 'Drawer';